import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function PropertyList() {
  return (
    <div>
        <Header />
           {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"  style={{
        backgroundImage: "url('assets/img/breadcrumb-bg.jpg')",
       
      }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Properties List</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                         Properties List
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- Project Section Start --> */}
        <section class="project-section section-padding">
            <div class="container">
                 <div class="gt-shop-notices-wrapper">
                    <div class="gt-shop-showing">
                        <p>Showing 1–14 of 26 results</p>
                    </div>
                    <div class="form-clt">
                        <div class="form">
                            <select class="single-select w-100">
                                <option> Sort by : Default</option>
                                <option> Sort by popularity</option>
                                <option>Sort by popularity</option>
                                <option> Sort by latest</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-8">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">Houses with Private Parking</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-02.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-02.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">Furnished Homes</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-03.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-03.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">Single-Family Homes</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-04.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-04.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">City Center Homes</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-05.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-05.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">Mid-Range Houses</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="project-box-items">
                                    <div class="project-thumb">
                                        <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                        <img src="assets/img/home-1/project/project-01.jpg" alt="img"/>
                                        <span class="project-post-box">
                                            PRICE $269
                                        </span>
                                    </div>
                                    <div class="project-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h3><a href="propertie-details.html">Houses with Private Parking</a></h3>
                                    <ul class="project-list">
                                        <li>
                                            <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                        1860 sqft
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                            Bed 6
                                        </li>
                                        <li>
                                            <img src="assets/img/home-1/project/user.png" alt="img"/>
                                        Bath 2
                                        </li>
                                    </ul>
                                    <a href="propertie-details.html" class="project-link-btn"><i class="flaticon-home"></i>View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="page-nav-wrap text-center">
                            <ul>
                                <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-left"></i></a></li>
                                <li class="active"><a class="page-numbers" href="#">01</a></li>
                                <li><a class="page-numbers" href="#">02</a></li>
                                <li><a class="page-numbers" href="#">03</a></li>
                                <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-right"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="propertie-list-sidebar">
                            <div class="propertie-widget-items">
                                <h3>Property Type</h3>
                                <div class="categories-list">
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                    <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                    Beauty
                                                </span>
                                            </span>
                                            <span class="text-color">100</span>
                                        </label>
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                    <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                    Studio
                                                </span>
                                            </span>
                                            <span class="text-color">50</span>
                                        </label>
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                    <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                   Apartment
                                                </span>
                                            </span>
                                            <span class="text-color">80</span>
                                        </label>
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                   <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                   Office
                                                </span>
                                            </span>
                                            <span class="text-color">90</span>
                                        </label>
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                    <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                    Luxury House
                                                </span>
                                            </span>
                                            <span class="text-color">150</span>
                                        </label>
                                        <label class="checkbox-single d-flex justify-content-between align-items-center">
                                            <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                                <span class="checkbox-area d-center">
                                                    <input type="checkbox"/>
                                                    <span class="checkmark d-center"></span>
                                                </span>
                                                <span class="text-color">
                                                    Flat
                                                </span>
                                            </span>
                                            <span class="text-color">200</span>
                                        </label>
                                </div>
                            </div>
                            <div class="propertie-widget-items">
                                <h3>Benefits</h3>
                                <div class="categories-list">
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                                Modern House
                                            </span>
                                        </span>
                                        <span class="text-color">100</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                                Car Parking
                                            </span>
                                        </span>
                                        <span class="text-color">50</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                                Dining Area
                                            </span>
                                        </span>
                                        <span class="text-color">80</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                                Bedroom
                                            </span>
                                        </span>
                                        <span class="text-color">90</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                               Sports Area
                                            </span>
                                        </span>
                                        <span class="text-color">150</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                                Security Camera
                                            </span>
                                        </span>
                                        <span class="text-color">200</span>
                                    </label>
                                </div>
                            </div>
                            <div class="propertie-widget-items">
                                <h3>Price Range</h3>
                                <div class="categories-list">
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                               Low Budget
                                            </span>
                                        </span>
                                        <span class="text-color">$5,000 - $10,000</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                               Medium
                                            </span>
                                        </span>
                                        <span class="text-color">$10,00 - $30,000</span>
                                    </label>
                                    <label class="checkbox-single d-flex justify-content-between align-items-center">
                                        <span class="d-flex gap-xl-3 gap-2 align-items-center">
                                            <span class="checkbox-area d-center">
                                                <input type="checkbox"/>
                                                <span class="checkmark d-center"></span>
                                            </span>
                                            <span class="text-color">
                                               High Budget
                                            </span>
                                        </span>
                                        <span class="text-color">$40,0000</span>
                                    </label>
                                </div>
                            </div>
                            <div class="propertie-widget-items">
                                <h3>Price Filter</h3>
                                <div class="price-range-wrapper">
                                    <div class="slider-container">
                                        {/* <!-- Range sliders --> */}
                                        <input type="range" id="min-slider" class="slider" min="130" max="500"
                                            value="130"/>
                                        <input type="range" id="max-slider" class="slider" min="130" max="500"
                                            value="250"/>
                                    </div>
                                    <div class="price-text pt-4 d-flex gap-3">
                                        <label for="amount">Price:</label>
                                        <input type="text" id="amount" readonly style={{border:0}}/>
                                    </div>
                                </div>
                            </div>
                            <div class="propertie-widget-items">
                                <h3>Categories</h3>
                                <ul class="gt-category-list">
                                    <li><a href="propertie-details.html">Buying </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    <li><a href="propertie-details.html">Renting  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    <li><a href="propertie-details.html">Market Update  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    <li><a href="propertie-details.html">House Construction  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    <li><a href="propertie-details.html">Selling  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    <li><a href="propertie-details.html">Investment </a><span><i class="flaticon-right-arrow"></i></span></li>
                                </ul>
                            </div>
                            <div class="propertie-widget-items">
                                <h3>Popular Tags</h3>
                                <div class="tagcloud">
                                    <a href="news-details.html">SmartHomes</a>     
                                    <a href="news-details.html">GreenLiving</a>
                                    <a href="news-details.html">LuxuryLiving</a>
                                    <a href="news-details.html">LegalAdvice</a>
                                    <a href="news-details.html">RealEstateTrends</a>
                                    <a href="news-details.html">HouseHunting</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         <Footer/>
    </div>
  )
}

export default PropertyList